import * as React from 'react';
import type { SVGProps } from 'react';
const SvgSsd = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} fill="currentColor" viewBox="0 0 50 50" {...props}>
        <path d="M7.688 0c-.958 0-1.72.66-1.875 1.594L.093 35.406C.036 35.594 0 35.796 0 36v12c0 1.094.906 2 2 2h46c1.094 0 2-.906 2-2V36c0-.297-.066-.59-.187-.844L44.187 1.594C44.032.66 43.27 0 42.314 0Zm.093 2H42.22l5.375 32H2.375ZM2 36h45.969c.008.02.02.043.031.063V48H2Zm5 4v5h27v-5h-2v3h-3v-3h-2v3h-3v-3h-2v3h-3v-3h-2v3h-3v-3h-2v3H9v-3Zm34 0a1.999 1.999 0 1 0 0 4 1.999 1.999 0 1 0 0-4Z" />
    </svg>
);
export default SvgSsd;
